<!-- ============ TOP UTILITY BAR ============ -->
<div id="top-header">
  <div class="container-fluid px-xl-4 px-xxl-5">
    <ul class="utility-nav">
      <li class="contact-mini left-item"><i class="fa-solid fa-envelope"></i> ssgians1&#64;gmail.com</li>
      <li class="contact-mini left-item"><i class="fa-solid fa-envelope"></i> ssji1525&#64;gmail.com</li>
      <li class="contact-mini left-item me-auto"><i class="fa-brands fa-whatsapp"></i> +91 9729458602</li>

      <li><a href="/assets/pdf/NAAC-metrices.pdf" target="_blank">NAAC</a></li>
      <li><a href="/assets/pdf/NIRF-DCS-Shah-Satnam-Ji-Girls-College-Sirsa.pdf" target="_blank">NIRF</a></li>
      <!-- <li><a href="/assets/pdf/lms-learning.pdf" target="_blank">LMS Online Learning</a></li> -->

      <!-- Research (Utility) -->
      <!-- <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Research</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/research/rd-cell">R&amp;D Cell</a></li>
          <li><a class="dropdown-item" routerLink="/mous">Industry Collaboration (MoUs)</a></li>
          <li><a class="dropdown-item" routerLink="/research/incubation">Incubation Centre</a></li>
        </ul>
      </li> -->

      <!-- Gallery (Utility) -->
      <!-- <li><a routerLink="/gallery">Gallery</a></li> -->

      <!-- Library -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Library</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/library/about-library">About Library</a></li>
          <li><a class="dropdown-item" routerLink="/library/n-list">N-List</a></li>
        </ul>
      </li>

      <!-- IQAC -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">IQAC</a>
        <ul class="dropdown-menu utility-dropdown iqac-wide">
          <li><a class="dropdown-item" routerLink="/iqac/about-iqac">About IQAC</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/formation">Formation of IQAC</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/iqac-meetings">IQAC Meetings</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/institutional-dist">Institutional Distinctiveness</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/best-prac">Best Practices</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/quality-initiatives">Quality Initiatives</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/quality-audits">Quality Audits</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/collaborative-initiatives">Collaborative Initiatives</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/conferences-seminars-workshops">Conferences, Seminars &amp;
              Workshops</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/aishe">AISHE</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/nirf">NIRF</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/aqar">AQAR</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/accreditation">Accreditation by NAAC</a></li>
          <li><a class="dropdown-item" routerLink="/iqac/feedback">Feedback</a></li>
        </ul>
      </li>

      <!-- Alumni -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Alumni</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/alumni/association">Alumni Association</a></li>
          <li><a class="dropdown-item" routerLink="/alumni/register">Register / Log In</a></li>
          <li><a class="dropdown-item" routerLink="/alumni/meet">Alumni Meet</a></li>
          <li><a class="dropdown-item" routerLink="/alumni/our-alumnus">Our Alumnus</a></li>
        </ul>
      </li>

      <!-- Plan Your Visit -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Plan Your Visit</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/visit/infrastructure">Infrastructure</a></li>
          <li><a class="dropdown-item" routerLink="/visit/how-to-reach">How to Reach Us</a></li>
        </ul>
      </li>

      <!-- Let Us Help You -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Let Us Help You</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/contact">Contact Us</a></li>
          <li><a class="dropdown-item" routerLink="/contact/email-directory">Email Directory</a></li>
          <li><a class="dropdown-item" routerLink="/contact/telephone-directory">Telephone Directory</a></li>
        </ul>
      </li>

      <!-- Info Corner -->
      <li class="dropdown util-dd">
        <a class="dropdown-toggle" role="button" tabindex="0">Info Corner</a>
        <ul class="dropdown-menu utility-dropdown">
          <li><a class="dropdown-item" routerLink="/info/rti-details">RTI Details</a></li>
          <li><a class="dropdown-item" routerLink="/info/job-openings">Job Openings</a></li>
          <li><a class="dropdown-item" routerLink="/info/notifications">Circulars &amp; Notices</a></li>
          <li><a class="dropdown-item" routerLink="/info/recent-events">Recent Events</a></li>
          <li><a class="dropdown-item" routerLink="/info/newsletters">Newsletters</a></li>
        </ul>
      </li>

      <!-- <li>
        <a href="https://odp.page.link/app" target="_blank" class="login-btn">
          <i class="fa-solid fa-user"></i> Student Login
        </a>
      </li>

      <li>
        <a href="" target="_blank" class="apply-now-btn">
          Apply Now <i class="fa-solid fa-arrow-right"></i>
        </a>
      </li> -->
    </ul>
  </div>
</div>

<!-- ============ MAIN CORE NAVIGATION ============ -->
<header id="main-header" [class.scrolled]="isScrolled">
  
  <!-- TOP BRANDING STRIP: College Name (Left) & Accreditations / Affiliations Logos (Right) -->
  <div class="header-top-branding py-2 d-none d-md-block">
    <div class="container-fluid px-xl-4 px-xxl-5 d-flex align-items-center justify-content-between">
      <!-- LEFT: College Name & Crest -->
      <a class="navbar-brand m-0" routerLink="/" (click)="closeMobileMenu()">
        <img src="/assets/img/logo/logo2.png" alt="Shah Satnam Ji Girls' College Sirsa" class="college-logo-img" />
      </a>

      <!-- RIGHT: UGC, AICTE, SWAYAM, CDLU, NIRF, NAAC Logos -->
      <div class="header-accreditation-wrapper d-none d-md-flex align-items-center">
        <img src="/assets/img/logo/logos.png" alt="UGC, AICTE, SWAYAM, CDLU, NIRF, NAAC Accreditations & Affiliations" class="header-accreditation-img" />
      </div>
    </div>
  </div>

  <nav class="navbar py-1">
    <div class="container-fluid px-xl-4 px-xxl-5">

      <!-- MOBILE BRANDING (Visible on Mobile) -->
      <a class="navbar-brand d-md-none m-0" routerLink="/" (click)="closeMobileMenu()">
        <img src="/assets/img/logo/logo2.png" alt="Shah Satnam Ji Girls College" class="mobile-logo-img" />
      </a>

      <!-- MOBILE RIGHT SIDE: Login + Hamburger -->
      <div class="mobile-actions">
        <!-- <a href="https://odp.page.link/app" target="_blank" class="mobile-login-btn">
          <i class="fa-solid fa-user"></i>
        </a> -->
        <button class="navbar-toggler" type="button" [class.active]="mobileMenuOpen" (click)="toggleMobileMenu($event)"
          aria-label="Toggle navigation" [attr.aria-expanded]="mobileMenuOpen">
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </button>
      </div>

      <!--
        BUG FIX: Original had (click)="closeMobileMenu()" on the overlay div.
        That created a double-close race with the document:click listener in the TS —
        both would fire on the same tap, causing erratic open/close behaviour on iOS.
        The overlay is now purely visual; closing on outside tap is handled exclusively
        by the document:click HostListener in header.component.ts.
      -->
      <div class="mobile-overlay" [class.show]="mobileMenuOpen" aria-hidden="true">
      </div>

      <!-- MAIN MENU DRAWER -->
      <div class="navbar-collapse" [class.show]="mobileMenuOpen" id="mainMenu" [attr.aria-hidden]="!mobileMenuOpen">

        <!-- Mobile drawer header -->
        <div class="drawer-header">
          <div class="drawer-logo-container bg-white px-2.5 py-1 rounded-2 shadow-sm">
            <img src="/assets/img/logo/logo2.png" alt="Shah Satnam Ji Girls' College" class="drawer-logo" />
          </div>
          <button class="drawer-close" type="button" (click)="closeMobileMenu()" aria-label="Close menu">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <ul class="navbar-nav main-nav">

          <!-- 1. HOME -->
          <li class="nav-item">
            <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMobileMenu()">
              Home
            </a>
          </li>

          <!-- 2. WHO WE ARE -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('who')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('who', $event)">
              Who We Are <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/about-us/our-history" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-landmark"></i> Our History</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/vision-mission" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-eye"></i> Vision &amp; Mission</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/principal-message" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-tie"></i> Principal Message</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/code-of-conduct" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-scale-balanced"></i> Code Of Conduct</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/college-anthem" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-music"></i> College Anthem</a></li>
              <li><a class="dropdown-item" routerLink="/about-us/prayer" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-hands-praying"></i> Prayer</a></li>
            </ul>
          </li>

          <!-- 3. ABOUT HEI -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('hei')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('hei', $event)">
              About HEI <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/hei/about-ssgc" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-building-columns"></i> About SSGC</a></li>
              <li><a class="dropdown-item" routerLink="/hei/act-statutes" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-gavel"></i> Act and Statutes</a></li>
              <li><a class="dropdown-item" routerLink="/hei/institutional-dev-plan" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-chart-line"></i> Institutional Dev Plan</a></li>
              <li><a class="dropdown-item" routerLink="/hei/affiliation" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-link"></i> Affiliation University</a></li>
              <li><a class="dropdown-item" routerLink="/hei/ranking" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-ranking-star"></i> Accreditation / Ranking System</a></li>
              <li><a class="dropdown-item" routerLink="/hei/annual-reports" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-file-invoice"></i> Annual Reports &amp; Accounts</a></li>
            </ul>
          </li>

          <!-- 4. ADMINISTRATION -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('admin')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('admin', $event)">
              Administration <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/admin/governing-body" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-people-roof"></i> Governing Body</a></li>
              <li><a class="dropdown-item" routerLink="/admin/principal" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-tie"></i> Principal</a></li>
              <li><a class="dropdown-item" routerLink="/admin/ombudsman" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-shield"></i> Ombudsman</a></li>
              <li><a class="dropdown-item" routerLink="/admin/executive-council" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-users-gear"></i> Executive Council</a></li>
              <li><a class="dropdown-item" routerLink="/admin/icc" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-shield-halved"></i> Internal Complaint Committee</a></li>
              <li><a class="dropdown-item" routerLink="/admin/hods" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-graduate"></i> Academic Leadership (HODs)</a></li>
              <li><a class="dropdown-item" routerLink="/admin/board-of-studies" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-book"></i> Board of Studies</a></li>
              <li><a class="dropdown-item" routerLink="/admin/cdc" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-diagram-project"></i> Executive Council (CDC)</a></li>
            </ul>
          </li>

          <!-- 5. ACADEMICS (MEGA) -->
          <li class="nav-item dropdown bigDropdown" [class.accordion-open]="isAccordionOpen('academics')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('academics', $event)">
              Academics <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <div class="dropdown-menu mega-menu compact-mega">
              <div class="row g-0">
                <div class="col-12 col-lg-5 mega-col">
                  <h6 class="mega-title-block">General &amp; Faculty</h6>
                  <div class="px-2">
                    <a class="dropdown-item" routerLink="/academics/programs" (click)="closeMobileMenu()">Academic
                      Programs</a>
                    <a class="dropdown-item" routerLink="/academics/student-strength"
                      (click)="closeMobileMenu()">Student
                      Strength</a>
                    <a class="dropdown-item" routerLink="/academics/time-table"
                      (click)="closeMobileMenu()">Time-Table</a>
                    <a class="dropdown-item" routerLink="/academics/value-added-courses"
                      (click)="closeMobileMenu()">Skill / Value Added Courses</a>
                    <a class="dropdown-item" routerLink="/academics/syllabus" (click)="closeMobileMenu()">Syllabus</a>
                    <a class="dropdown-item" routerLink="/academics/calendar" (click)="closeMobileMenu()">Academic
                      Calendar</a>
                    <a class="dropdown-item" routerLink="/library/about-library" (click)="closeMobileMenu()">Library</a>
                    <a class="dropdown-item" routerLink="/mous" (click)="closeMobileMenu()">MoUs</a>
                    <a class="dropdown-item" routerLink="/internships" (click)="closeMobileMenu()">Internships</a>
                    <a class="dropdown-item" routerLink="/placements" (click)="closeMobileMenu()">Placements</a>

                    <hr class="my-2 opacity-10">

                    <a class="dropdown-item" routerLink="/faculty/teaching" (click)="closeMobileMenu()">Teaching
                      Staff</a>
                    <a class="dropdown-item" routerLink="/faculty/non-teaching" (click)="closeMobileMenu()">Non-Teaching
                      Staff</a>
                  </div>
                </div>
                <div class="col-12 col-lg-7 mega-col mega-col-bordered">
                  <h6 class="mega-title-block">Departments &amp; Courses</h6>
                  <div class="row g-0 px-2">
                    <div class="col-6">
                      <a class="dropdown-item" routerLink="/department/chemistry"
                        (click)="closeMobileMenu()">Chemistry</a>
                      <a class="dropdown-item" routerLink="/department/commerce-management"
                        (click)="closeMobileMenu()">Commerce &amp; Mgmt.</a>
                      <a class="dropdown-item" routerLink="/department/computer-science"
                        (click)="closeMobileMenu()">Computer Science</a>
                      <a class="dropdown-item" routerLink="/department/economics"
                        (click)="closeMobileMenu()">Economics</a>
                      <a class="dropdown-item" routerLink="/department/english" (click)="closeMobileMenu()">English</a>
                      <a class="dropdown-item" routerLink="/department/geography"
                        (click)="closeMobileMenu()">Geography</a>
                      <a class="dropdown-item" routerLink="/department/hindi" (click)="closeMobileMenu()">Hindi</a>
                    </div>
                    <div class="col-6">
                      <a class="dropdown-item" routerLink="/department/home-science" (click)="closeMobileMenu()">Home
                        Science</a>
                      <a class="dropdown-item" routerLink="/department/mass-communication"
                        (click)="closeMobileMenu()">Mass Communication</a>
                      <a class="dropdown-item" routerLink="/department/mathematics"
                        (click)="closeMobileMenu()">Mathematics</a>
                      <a class="dropdown-item" routerLink="/department/physical-education"
                        (click)="closeMobileMenu()">Physical Education</a>
                      <a class="dropdown-item" routerLink="/department/physics" (click)="closeMobileMenu()">Physics</a>
                      <a class="dropdown-item" routerLink="/department/psychology"
                        (click)="closeMobileMenu()">Psychology</a>
                      <a class="dropdown-item" routerLink="/department/punjabi" (click)="closeMobileMenu()">Punjabi</a>
                      <a class="dropdown-item" routerLink="/department/public-administration"
                        (click)="closeMobileMenu()">Public Administration</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- 6. ADMISSION & FEE -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('admission')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('admission', $event)">
              Admission &amp; Fee <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/admissions/prospectus" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-book-open"></i> Prospectus</a></li>
              <li><a class="dropdown-item" routerLink="/admissions/ug" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-graduate"></i> UG Admission Guidelines</a></li>
              <li><a class="dropdown-item" routerLink="/admissions/pg" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-graduate"></i> PG Admission Guidelines</a></li>
              <li><a class="dropdown-item" routerLink="/admissions/registration" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-pen-to-square"></i> Registration for Admissions</a></li>
              <li><a class="dropdown-item" routerLink="/admissions/fees-scholarships" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-handshake-angle"></i> Fees &amp; Scholarships</a></li>
            </ul>
          </li>



          <!-- 8. STUDENT LIFE (MEGA) -->
          <li class="nav-item dropdown bigDropdown" [class.accordion-open]="isAccordionOpen('student')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('student', $event)">
              Student Life & Facilities <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>

            <div class="dropdown-menu mega-menu compact-mega">
              <!-- Row 1: Academic Facilities & Student Facilities -->
              <div class="row g-0">
                <div class="col-12 col-lg-6 mega-col">
                  <h6 class="mega-title-block">Academic Facilities</h6>
                  <div class="px-2">
                    <a class="dropdown-item" routerLink="/campus-life/facilities/smart-classrooms"
                      (click)="closeMobileMenu()">Smart Class Rooms</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/media-lab"
                      (click)="closeMobileMenu()">Media Production and Editing Lab</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/computer-lab"
                      (click)="closeMobileMenu()">Computer Lab</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/science-lab"
                      (click)="closeMobileMenu()">Science Lab</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/geography-lab"
                      (click)="closeMobileMenu()">Geography Lab</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/psychology-lab"
                      (click)="closeMobileMenu()">Psychology Lab</a>
                    <a class="dropdown-item" routerLink="/campus-life/facilities/dance-room"
                      (click)="closeMobileMenu()">Dance Room</a>
                  </div>
                </div>
                <div class="col-12 col-lg-6 mega-col mega-col-bordered">
                  <h6 class="mega-title-block">Student Facilities</h6>
                  <div class="px-2">
                    <div class="row g-0">
                      <div class="col-12 col-md-6">
                        <a class="dropdown-item" routerLink="/student-facilities/sports"
                          (click)="closeMobileMenu()">Sports</a>
                        <a class="dropdown-item" routerLink="/student-facilities/culture-music"
                          (click)="closeMobileMenu()">Culture &amp; Music</a>
                        <a class="dropdown-item" routerLink="/research/incubation"
                          (click)="closeMobileMenu()">Incubation Startup</a>
                        <a class="dropdown-item" routerLink="/placements" (click)="closeMobileMenu()">Placement Cell</a>
                        <a class="dropdown-item" routerLink="/internships" (click)="closeMobileMenu()">Internships</a>
                      </div>
                      <div class="col-12 col-md-6">
                        <a class="dropdown-item" routerLink="/student-facilities/scholarship"
                          (click)="closeMobileMenu()">Scholarship</a>
                        <a class="dropdown-item" routerLink="/student-facilities/freeship"
                          (click)="closeMobileMenu()">Freeship</a>
                        <a class="dropdown-item" routerLink="/student-facilities/remedial-classes"
                          (click)="closeMobileMenu()">Remedial Classes</a>
                        <a class="dropdown-item" routerLink="/student-facilities/health"
                          (click)="closeMobileMenu()">Health Facilities</a>
                        <a class="dropdown-item" routerLink="/student-facilities/career-guidance"
                          (click)="closeMobileMenu()">Career Guidance &amp; Placement Cell</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Row Divider for Desktop -->
              <hr class="my-3 opacity-10 d-none d-lg-block">

              <!-- Row 2: Cells & Clubs & Others -->
              <div class="row g-0">
                <div class="col-12 col-lg-6 mega-col">
                  <h6 class="mega-title-block">Cells &amp; Clubs</h6>
                  <div class="px-2">
                    <a class="dropdown-item" routerLink="/campus-life/ncc" (click)="closeMobileMenu()">NCC</a>
                    <a class="dropdown-item" routerLink="/campus-life/nss" (click)="closeMobileMenu()">NSS</a>
                    <a class="dropdown-item" routerLink="/campus-life/youth-red-cross" (click)="closeMobileMenu()">Youth
                      Red Cross</a>
                    <a class="dropdown-item" routerLink="/campus-life/red-ribbon-club" (click)="closeMobileMenu()">Red
                      Ribbon Club</a>
                    <a class="dropdown-item" routerLink="/student-facilities/anti-ragging"
                      (click)="closeMobileMenu()">Anti Ragging Cell</a>
                    <a class="dropdown-item" routerLink="/student-facilities/equal-opportunity"
                      (click)="closeMobileMenu()">Equal Opportunity Cell</a>
                    <a class="dropdown-item" routerLink="/student-facilities/differently-abled"
                      (click)="closeMobileMenu()">Facilities for Differently Abled</a>
                  </div>
                </div>
                <div class="col-12 col-lg-6 mega-col mega-col-bordered">
                  <h6 class="mega-title-block">Others</h6>
                  <div class="px-2">
                    <a class="dropdown-item" routerLink="/campus-life/grievances-icc"
                      (click)="closeMobileMenu()">Grievances Redressal &amp; ICC</a>
                    <a class="dropdown-item" routerLink="/campus-life/campus-facilities"
                      (click)="closeMobileMenu()">Campus Facilities</a>
                    <a class="dropdown-item" routerLink="/campus-life/green-campus" (click)="closeMobileMenu()">Green
                      Campus</a>
                    <a class="dropdown-item" routerLink="/campus-life/best-practices" (click)="closeMobileMenu()">Best
                      Practices</a>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- 11. GRIEVANCES -->
          <li class="nav-item dropdown" [class.accordion-open]="isAccordionOpen('grievances')">
            <a class="nav-link dropdown-toggle" (click)="toggleAccordion('grievances', $event)">
              Grievances <i class="fa-solid fa-chevron-down toggle-icon"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" routerLink="/grievances/submit" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-paper-plane"></i> Submit Grievance</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/objectives" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-bullseye"></i> Objectives</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/functions" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-gears"></i> Functions</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/ombudsperson" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-user-shield"></i> Ombudsperson</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/committee" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-users"></i> Committee</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/redressal" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-handshake-angle"></i> Grievance Redressal</a></li>
              <li><a class="dropdown-item" routerLink="/grievances/policy" (click)="closeMobileMenu()">
                  <i class="fa-solid fa-file-shield"></i> Grievance Policy</a></li>
            </ul>
          </li>

        </ul>

      </div><!-- end navbar-collapse -->
    </div>
  </nav>
</header>

<!-- Vertical Floating Enquiry Button — HOME ONLY -->
<div class="side-enquiry-btn" *ngIf="isHome">
  <a routerLink="/admissions/registration" class="enquiry-link">
    Apply Now
  </a>
</div>

<!-- Social Sidebar — HOME ONLY -->
<div class="social-sidebar" *ngIf="isHome">
  <!-- Social Links -->
  <a href="https://www.facebook.com/shahsatnamjigirlscollegesirsa/" target="_blank" class="social-link facebook"
    title="Facebook">
    <i class="fab fa-facebook-f"></i>
  </a>

  <a href="https://www.youtube.com/channel/UCZSxE3ywZQA_xXVbNP3vSFw" target="_blank" class="social-link youtube"
    title="YouTube">
    <i class="fab fa-youtube"></i>
  </a>
  <a href="https://www.instagram.com/shahsatnamjigirlscollegesirsa?igsh=MW9veGtwc3d2ZDlpNA==" target="_blank"
    class="social-link instagram" title="Instagram">
    <i class="fab fa-instagram"></i>
  </a>
  <a href="https://share.google/ZV5w2ThpVrjKGe8H5" target="_blank" class="social-link threads" title="Threads">
    <i class="fab fa-threads"></i>
  </a>

  <!-- Divider -->
  <div class="sidebar-divider"></div>

  <!-- Search Toggle -->
  <button class="social-link search-btn" (click)="toggleSearch()" title="Search">
    <i class="fa fa-search"></i>
  </button>

  <!-- Language Toggle -->
  <button class="social-link lang-btn" (click)="triggerTranslate()"
    [title]="isHindi ? 'Switch to English' : 'Switch to Hindi'">
    <span class="lang-label">{{ isHindi ? 'EN' : 'HI' }}</span>
  </button>
</div>

<!-- Search Overlay — HOME ONLY -->
<div class="search-overlay" [class.active]="searchOpen" (click)="closeSearch($event)" *ngIf="isHome">
  <div class="search-container" (click)="$event.stopPropagation()">
    <div class="search-box">
      <input type="text" [(ngModel)]="searchQuery" (input)="onSearchChange()" (keyup.enter)="doSearch()"
        placeholder="Search the website..." class="search-input">
      <button (click)="doSearch()" class="search-submit"><i class="fa-solid fa-magnifying-glass"></i></button>
      <button (click)="toggleSearch()" class="search-close"><i class="fa-solid fa-xmark"></i></button>
    </div>

    <!-- Search Results Dropdown -->
    <div class="search-results-wrapper" *ngIf="searchQuery">
      <div *ngIf="searchResults.length > 0">
        <div class="search-result-item" *ngFor="let result of searchResults">
          <a [routerLink]="result.path" (click)="closeSearchDirectly()">
            <span class="result-category">{{ result.category }}</span>
            <span class="result-title">{{ result.title }}</span>
            <span class="result-desc">{{ result.description }}</span>
          </a>
        </div>
      </div>
      <div class="no-results-msg" *ngIf="searchResults.length === 0">
        <i class="fa-solid fa-magnifying-glass"></i>
        <span>No results found for "{{ searchQuery }}"</span>
      </div>
    </div>
  </div>
</div>